"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelCardDtoToJSON = exports.PanelCardDtoFromJSONTyped = exports.PanelCardDtoFromJSON = exports.instanceOfPanelCardDto = exports.PanelCardDtoAggregationTypeEnum = void 0;
var runtime_1 = require("../runtime");
var CategoryForPanelDetailedPageDto_1 = require("./CategoryForPanelDetailedPageDto");
var OptTestForPanelCardDto_1 = require("./OptTestForPanelCardDto");
var SimpleCommercialTestDto_1 = require("./SimpleCommercialTestDto");
/**
 * @export
 */
exports.PanelCardDtoAggregationTypeEnum = {
    Gene: 'CT_GENE',
    Group: 'CT_GROUP',
    Opt: 'CT_OPT'
};
/**
 * Check if a given object implements the PanelCardDto interface.
 */
function instanceOfPanelCardDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPanelCardDto = instanceOfPanelCardDto;
function PanelCardDtoFromJSON(json) {
    return PanelCardDtoFromJSONTyped(json, false);
}
exports.PanelCardDtoFromJSON = PanelCardDtoFromJSON;
function PanelCardDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !(0, runtime_1.exists)(json, 'code') ? undefined : json['code'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'tags': !(0, runtime_1.exists)(json, 'tags') ? undefined : json['tags'],
        'totalGenesCount': !(0, runtime_1.exists)(json, 'totalGenesCount') ? undefined : json['totalGenesCount'],
        'aggregationType': !(0, runtime_1.exists)(json, 'aggregationType') ? undefined : json['aggregationType'],
        'productType': !(0, runtime_1.exists)(json, 'productType') ? undefined : json['productType'],
        'geneTests': !(0, runtime_1.exists)(json, 'geneTests') ? undefined : (json['geneTests'].map(SimpleCommercialTestDto_1.SimpleCommercialTestDtoFromJSON)),
        'optTests': !(0, runtime_1.exists)(json, 'optTests') ? undefined : (json['optTests'].map(OptTestForPanelCardDto_1.OptTestForPanelCardDtoFromJSON)),
        'categories': !(0, runtime_1.exists)(json, 'categories') ? undefined : (json['categories'].map(CategoryForPanelDetailedPageDto_1.CategoryForPanelDetailedPageDtoFromJSON)),
    };
}
exports.PanelCardDtoFromJSONTyped = PanelCardDtoFromJSONTyped;
function PanelCardDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'name': value.name,
        'tags': value.tags,
        'totalGenesCount': value.totalGenesCount,
        'aggregationType': value.aggregationType,
        'productType': value.productType,
        'geneTests': value.geneTests === undefined ? undefined : (value.geneTests.map(SimpleCommercialTestDto_1.SimpleCommercialTestDtoToJSON)),
        'optTests': value.optTests === undefined ? undefined : (value.optTests.map(OptTestForPanelCardDto_1.OptTestForPanelCardDtoToJSON)),
        'categories': value.categories === undefined ? undefined : (value.categories.map(CategoryForPanelDetailedPageDto_1.CategoryForPanelDetailedPageDtoToJSON)),
    };
}
exports.PanelCardDtoToJSON = PanelCardDtoToJSON;
